<dx-box width="100%" height="100%" direction="col">
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-work-order-grid
                workOrderStatus="open"
                [isPopup]="isPopup"
                [workOrdersGridSource]="openWorkOrders"
                [workOrderIds]="workOrderIds"
                [showOnlyLinked]="showOnlyLinked"
                (onForceReload)="forceRefresh()"
                (onWorkOrderSelection)="onWorkOrderRecordsSelection($event)"
                (onWorkOrderDeselection)="onWorkOrderRecordsDeselection($event)"
            ></app-work-order-grid>
        </div>
    </dxi-item>
</dx-box>
